// extracted by mini-css-extract-plugin
export var fullHeightState = "_3v-7";
export var headerCell = "_3v-1";
export var loadingStateCell = "_3v-4";
export var rowWrapper = "_3v-3";
export var standaloneTable = "_3v-8";
export var standaloneTableWithBodyFill = "_3v-9";
export var stateCell = "_3v-5";
export var table = "_3v-0";
export var tableBodyFiller = "_3v-6";
export var white = "_3v-2";